import { BaseParameterDto } from './base-parameter-dto';

export class AccountParameterDto extends BaseParameterDto {
  intacctId: string;
  customerID: string;
  checkDigit: number;
}
